import React, {memo} from 'react'
import {Droppable, Draggable} from "react-beautiful-dnd";
import "./Getter.sass";

function getStyle(style, snapshot) {
    if (!snapshot.isDropAnimating) {
        return {
            ...style,
        };
    }
    return {
        ...style,
        transitionDuration: `0.001s`,
    };
}

const Getter = ({ droppedItem,  className, style, isDropDisabled, realIndex}) => {
    let imgUrl = null;
    if(droppedItem){
        if(droppedItem.special){
            Object.keys(droppedItem.special).map(keys => {
                return keys.split(",").filter(key => {
                    if(realIndex === Number(key)){
                        return imgUrl = droppedItem.special[keys]
                    }
                    return false
                })
            })
            if(!imgUrl){
                imgUrl = droppedItem.images.preview
            }

        }else{
            imgUrl = droppedItem.images.preview
        }
    }

    return(
        <div style={{...style}} className={`${className} Getter`}>
            <Droppable
                droppableId={className}
                isDropDisabled={isDropDisabled}
                ignoreContainerClipping={true}

            >
                {(provided, snapshot) => {
                    return (
                        <div
                            className={`Getter-content ${!isDropDisabled ? "Getter-active" : ""} ${snapshot.isDraggingOver ? "Getter-over": ""} ${droppedItem ? "Getter-has-item": ""}`}
                            ref={provided.innerRef}
                        >
                            {droppedItem && (
                                <div className="Getter-container">
                                <Draggable
                                    key={droppedItem.itemId}
                                    draggableId={droppedItem.itemId}
                                    index={0}>
                                    {(provided, snapshot) => {
                                        return (
                                            <>
                                                <img
                                                    className="Getter-image"
                                                    ref={provided.innerRef}
                                                    {...provided.draggableProps}
                                                    src={imgUrl}
                                                    alt=""
                                                    style={getStyle(provided.draggableProps.style, snapshot)}
                                                />
                                                <div className="Getter-drag" {...provided.dragHandleProps}/>
                                            </>
                                        )
                                    }}
                                </Draggable>
                                </div>
                            )}
                            <div className="placeholder-wrapper">
                                {provided.placeholder}
                            </div>
                        </div>
                    )
                }}
            </Droppable>
        </div>

    )

}
export default memo(Getter)
